@if (offer) {
  <div id="spacer" style="width: 100%; height: 10px; background-color: transparent;" ></div>
  <div
    class="card-content-group"
    [class.collapsed]="isCollapsed(index)"
    [class.horizontal]="isHorizontalMode()"
    [lxResponsiveClass]="{ horizontal: 'card-content-group-desktop', vertical: 'container card-content-group-handset' }">

    <div
      class="content-wrapper"
      [class.collapsed-mobile]="isVerticalMode() && isCollapsed(index)">

      <!-- Content Area (Click to Expand) -->
      <div
        class="content-clickable"
        (click)="toggleCollapse(index)">
        <div

          class="content-list"
          [class.full-width]="isVerticalMode()">
          @for (attr of tapForDetails(index, offer); track attr; let j = $index) {
            <div
              class="card-content-handset glow"
              [ngClass]="contentStyle(index, j)">
              <li [class.invisible]="attr === ''"></li>
              <p class="content-text">
                <span [ngClass]="toggleTextContainerExpanded(index)">
                  @if (attr.toLowerCase().startsWith('summary')) {
                    <span>{{ attr.substring(attr.indexOf(':') + 1, attr.length) }}</span>
                  } @else {
                    @if (isExpanded(index)) {
                      <span [hidden]="">{{ attr.substring(0, attr.indexOf(':')) }}</span>
                      <span
                      [ngClass]="toggleTextContainerExpanded(index)">{{ attr.substring(attr.indexOf(':'), attr.length) }}</span>
                    }
                  }
                </span>
              </p>
            </div>
          }
          @if (!isExpanded(index)) {
            <p class="more-opacity content-text text-container"
              [lxResponsiveClass]="{ horizontal: 'text-tap-for-details-horizontal', vertical: 'text-tap-for-details-handset' }"
            >tap for details...</p>
          }
        </div>
      </div>
    </div>

    <div [hidden]="(offer.amenities.tags && offer.amenities.tags.length > 0)" class="tag-row-spacer"></div>

    @if (isHorizontalMode() && isCollapsed(index)) {

      <div>
        @if (sharedService.requestOnlyMode) {
          <button
            class="button-offer-card button-action button-add-to-cart"
            data-theme-key="--cta-bg1"
            [lxResponsiveClass]="{ horizontal: 'card-action-desktop', vertical: 'card-action-handset' }"
            [class.button-disabled]="checkIfDisabled()"
            (click)="requestUpgrade();">
            <span class="material-icons cart-icon">add_shopping_cart</span>
            <span class="cart-label">Request Upgrade</span>
          </button>
        }

        @if (!sharedService.requestOnlyMode && !checkIfOfferInCart()) {
          <button
            class="button-offer-card button-action button-add-to-cart"
            data-theme-key="--cta-bg1"
            [lxResponsiveClass]="{ horizontal: 'card-action-desktop', vertical: 'card-action-handset' }"
            type="button"
            [class.button-disabled]="checkIfDisabled()"
            (click)="addToCartAndContinue($event);">
            <span class="material-icons cart-icon">add_shopping_cart</span>
            <span class="cart-label">Add to Cart</span>
          </button>
        }

        @if (!sharedService.requestOnlyMode && checkIfOfferInCart()) {
          <button
            class="button-offer-card button-action button-add-to-cart"
            data-theme-key="--cta-bg1"
            [lxResponsiveClass]="{ horizontal: 'card-action-desktop', vertical: 'card-action-handset' }"
            [class.button-disabled]="checkIfDisabled()"
            (click)="removeOfferFromCart()">
            <span class="material-icons cart-icon">remove_shopping_cart</span>
            <span class="cart-label">Remove</span>
          </button>
        }


      </div>

    }



    <!-- Expanded/Mobile Buttons -->
    <div [lxResponsiveClass]="{ horizontal: 'offer-actions-desktop', vertical: 'offer-actions-handset' }"
      style="width: 100%; margin-top: 10px !important; transform: translateY(0px);"
         data-theme-key="--cta-bg1 --cta-bg2 --cta-shadow --cta-text"
         >
      @if (!isHorizontalMode() || !isCollapsed(index)) {
        @if (sharedService.requestOnlyMode) {
          <button
            class="button-offer-card"
            [lxResponsiveClass]="{ horizontal: 'card-action-desktop', vertical: 'card-action-handset' }"
            [class.expanded-margin]="isExpanded(index)"
            [class.button-disabled]="checkIfDisabled()"
            (click)="requestUpgrade()">
            <span class="material-icons cart-icon">add_shopping_cart</span>
            <span class="cart-label">Request Upgrade</span>
          </button>
        }

        @if (!sharedService.requestOnlyMode && !checkIfOfferInCart()) {
          <button
            class="button-offer-card"
            [lxResponsiveClass]="{ horizontal: 'card-action-desktop', vertical: 'card-action-handset' }"
            [class.expanded-margin]="isExpanded(index)"
            type="button"
            [class.button-disabled]="checkIfDisabled()"
            (click)="addToCartAndContinue($event);">
            <span class="material-icons cart-icon">add_shopping_cart</span>
            <span class="cart-label">Add to Cart</span>
          </button>
        }

        @if (!sharedService.requestOnlyMode && checkIfOfferInCart()) {
          <button
            class="button-offer-card"
            [lxResponsiveClass]="{ horizontal: 'card-action-desktop', vertical: 'card-action-handset' }"
            [class.expanded-margin]="isExpanded(index)"
            [class.button-disabled]="checkIfDisabled()"
            (click)="removeOfferFromCart()">
            <span class="material-icons cart-icon">remove_shopping_cart</span>
            <span class="cart-label">Remove</span>
          </button>
        }
      }

      <!-- Mobile Price Display -->
      @if (isVerticalMode()) {
        <div class="card-header-price-handset card-title-price-handset">
          <p class="price-display">
            @if (shouldShowStrike(offer)) {
              <span class="price-strike">
                {{ offer.bar_price | currency:'USD' : 'symbol' : '1.0-0' }}
              </span>
            }
            <span class="price-regular"> {{ offer.ofr_price | currency:'USD' : 'symbol' : '1.2-2' }}
            Per Night Extra</span>
          </p>
        </div>
      }
    </div>

    <div *lxViewport="'horizontal'" class="spacer"></div>
  </div>
}
